import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";

const RangeSlider = ({ rangeId, lstRanges, updateStudentCounts, closeSlider }) => {
    const [rangeKm, setRangeKm] = useState("");
    const [fees, setFees] = useState("");

    useEffect(() => {
        const range = lstRanges.find((r) => r.rangeId === rangeId);
        if (range) {
            setRangeKm(range.km || "");
            setFees(range.fees || "");
        } else {
            setRangeKm("");
            setFees("");
        }
    }, [rangeId, lstRanges]);

    const saveRange =  () => {
        if (!rangeKm || rangeKm <= 0) {
            toast.error("Range (in km) is required and must be greater than 0.");
            return;
        }
        if (!fees || fees <= 0) {
            toast.error("Fees are required and must be greater than 0.");
            return;
        }

        const newRange = {
            rangeId: rangeId || lstRanges.length + 1,
            km: parseFloat(rangeKm),
            fees: parseInt(fees, 10),
            count: rangeId === 0 ? 0 : undefined,
        };

        let tempLstRange;
        if (rangeId === 0) {
            // For a new range, append to the existing array
            tempLstRange = [...lstRanges, newRange];
        } else {
            // For an existing range, update the relevant item in the array
            tempLstRange = lstRanges.map((r) =>
                r.rangeId === rangeId ? { ...r, km: parseFloat(rangeKm), fees: parseInt(fees, 10) } : r
            );
        }
        
        // Pass the temporary array to updateStudentCounts for further processing
        updateStudentCounts(tempLstRange);
        closeSlider();
    };

    return (
        <div>
            <button
                type="button"
                className="btn btn-info text-center btnCloseDiv"
                onClick={closeSlider}
                style={{ right: "50%" }}
            >
                <span id="close" title="Close Slider" className="glyphicon glyphicon-remove"></span>
            </button>
            <div
                className="col-md-12 col-xs-12 col-centered padding-remove"
                style={{ marginTop: "30px", marginBottom: "30px" }}
            >
                <form className="form form-horizontal">
                    <div className="form-group col-md-12" style={{
                        width: '94%',
                        margin: '3% ',
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '10px',
                        padding: "20px 20px 5px 20px",
                    }}>
                        {/* Range (in km) */}
                        <div className="form-group col-md-12 padding-remove">
                            <label className="control-label col-md-4" style={{ padding: "7px 0 0 0" }}>
                                Range (in km):
                            </label>
                            <div className="col-sm-3">
                                <input
                                    type="number"
                                    className="form-control"
                                    min="0.1"
                                    step="0.1"
                                    value={rangeKm}
                                    onChange={(e) => setRangeKm(e.target.value)}
                                    placeholder="Enter range in km"
                                />
                            </div>
                        </div>

                        {/* Fees */}
                        <div className="form-group col-md-12 padding-remove">
                            <label className="control-label col-md-4" style={{ padding: "7px 0 0 0" }}>
                                Fees:
                            </label>
                            <div className="col-sm-3">
                                <input
                                    type="number"
                                    className="form-control"
                                    min="1"
                                    step="1"
                                    value={fees}
                                    onChange={(e) => setFees(e.target.value)}
                                    placeholder="Enter fees"
                                />
                            </div>
                        </div>

                        {/* Save Button */}
                        <div className="col-sm-10 padding-remove" style={{ height: "50px", marginTop: "20px" }}>
                            <div className="col-sm-2 col-md-2 padding-remove pull-right">
                                <button type="button" className="btn btn-info" onClick={saveRange}>
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default RangeSlider;

